import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-ineligibility-dialog',
    templateUrl: './ineligibility-dialog.component.html',
    styleUrls: ['./ineligibility-dialog.component.scss'],
    standalone: false
})
export class IneligibilityDialogComponent {
  @Input() message: string;
  @Output() closeDialog = new EventEmitter<void>();

  onClose(): void {
    this.closeDialog.emit();
  }
}
